import React, { useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom';
import { StoreTransactionType } from '../../../types/enum/transactionStatus';
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';
import { useStoreTransactions } from '../../../hooks/store/transactions';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import EmptyData from '../../../components/ui/EmptyData';
import TransactionsTable from '../../../components/store/trasnactions/TransactionsTable';
import Pagination from '../../../components/ui/Pagination';
import CustomModal from '../../../components/ui/CustomModal';
import StoreBalanceForm from '../../../components/admin/stores/transactions/StoreBalanceForm';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function StoreOverviewTransactions() {
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;
    const {t} = useTranslation();
        const [searchParams,setSearchParams] = useSearchParams();
        const pageQuery = Number(searchParams.get('page')) || 1;
        const category = searchParams.get("category")||"";
        const {data:transactions,isError,isLoading} = useStoreTransactions({page:pageQuery,status:category,storeId:numericStoreId});
    const categories=[
        {id:StoreTransactionType.COMPLETED,name:t(StoreTransactionType.COMPLETED)},
        {id:StoreTransactionType.CANCELED,name:t(StoreTransactionType.CANCELED)},
        {id:StoreTransactionType.REFUND,name:t(StoreTransactionType.REFUND)},
        {id:StoreTransactionType.SETTLEMENT,name:t(StoreTransactionType.SETTLEMENT)},
    ];

     const handlePagination = (page: number) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', page.toString());
        setSearchParams(newParams);
    };

        const [isOpen, setIsOpen] = useState(false);
    


  return (
    <Layout title={t('transactionsList')} headline={t('transactions_headline',{num:transactions?.data.length})}>
        <CategoriesSection
        selectedCategory={category?category:""}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={""}
        buttonLabel=''
        showAdd={false}
        notShowAddButton={true}
      />
      {/* ✅ Add this section */}
        {
          numericStoreId &&
          <PermissionGate permissions={[PermissionsKey.StoreBalanceAction]}>
            <div className="flex justify-end mb-4">
            <button
              onClick={() => setIsOpen(true)}
              className="px-4 py-2 bg-primary text-white font-semibold rounded-lg shadow hover:bg-primary/90 transition"
            >
              {t("manage_store_balance")}
            </button>
          </div>
          </PermissionGate>
        }
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {
        transactions && (
          transactions.data.length === 0 ?<EmptyData/> : <TransactionsTable transactions={transactions.data}/>
        )
      }
      <Pagination
        currentPage={pageQuery}
        totalPages={transactions?.totalPages||0}
        handlePagination={handlePagination}
      />
      <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t("manage_store_balance")}
      >
        <StoreBalanceForm
          storeId={Number(storeId)}
          onSubmitSuccess={() => setIsOpen(false)}
        />
      </CustomModal>
    </Layout>
  )
}

export default StoreOverviewTransactions